<template>
  <div>
    <Accordion
      :is-open="false"
      class="pega-visible"
    >
      <template #head>
        さらに絞り込む
      </template>
      <template #body>
        <div class="boss-table-2">
          <scout-form-scouted-date v-bind.sync="filterData.sendDate" />
          <scout-form-member-id
            v-model.number="filterData.userId"
            half
          />
          <scout-form-scouted-count
            v-model="filterData.sendCount"
            half
          />
          <scout-form-pull-down
            v-model="filterData.readingStatus"
            :options="readingStatusOptions"
            label="スカウト閲覧状態"
            half
            data-test="reading-status"
          />
          <scout-form-pull-down
            v-model="filterData.searchConditionName"
            :options="searchConditionNames"
            label="検索条件名"
            half
            data-test="search-condition-name"
          />
          <scout-form-pull-down
            v-model="filterData.subject"
            :options="subjects"
            label="スカウト件名"
            half
            class="width-100"
            data-test="subject"
          />
          <scout-form-pull-down
            v-model="filterData.reservedInfo"
            :options="reservedInfos"
            label="スカウト予約"
            half
            class="width-100"
            data-test="reserve-info"
          />
          <scout-form-gender
            v-model="filterData.gender"
            half
          />
          <scout-form-employed
            v-model="filterData.employed"
            half
          />
          <scout-form-prefecture
            v-if="renderModal"
            v-model="filterData.presentAddressPrefectures"
            label="現住所都道府県"
          />
          <scout-form-educational-background v-model="filterData.educationalBackground" />
          <scout-form-others
            half
            v-bind.sync="filterData"
          />
          <scout-form-special-favor v-model="filterData.specialFavorIds" />
        </div>
      </template>
    </Accordion>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import Accordion from '@/components/atoms/Accordion'
import { createDate } from '@/lib/dateUtils.js'
import * as definition from '@/lib/labelValueMappings'
import _ from 'lodash'
import ScoutFormEducationalBackground from '@/components/atoms/ScoutFormEducationalBackground'
import ScoutFormEmployed from '@/components/atoms/ScoutFormEmployed'
import ScoutFormGender from '@/components/atoms/ScoutFormGender'
import ScoutFormScoutedDate from '@/components/atoms/ScoutFormScoutedDate'
import ScoutFormMemberId from '@/components/atoms/ScoutFormMemberId'
import ScoutFormScoutedCount from '@/components/atoms/ScoutFormScoutedCount'
import ScoutFormPullDown from '@/components/atoms/ScoutFormPullDown'
import ScoutFormPrefecture from '@/components/atoms/ScoutFormPrefecture'
import ScoutFormOthers from '@/components/atoms/ScoutFormOthers'
import ScoutFormSpecialFavor from '@/components/atoms/ScoutFormSpecialFavor'

const defaultFilterData = {
  gender: null,
  educationalBackground: null,
  employed: null,
  hasCareerResumes: false,
  sendDate: {
    from: '',
    to: ''
  },
  userId: null,
  sendCount: null,
  readingStatus: '',
  searchConditionName: '',
  subject: '',
  presentAddressPrefectures: [],
  excludesLiked: false,
  includesResend: false,
  specialFavorIds: [],
  reservedInfo: ''
}

export default {
  components: {
    Accordion,
    ScoutFormEducationalBackground,
    ScoutFormEmployed,
    ScoutFormGender,
    ScoutFormScoutedDate,
    ScoutFormMemberId,
    ScoutFormScoutedCount,
    ScoutFormPullDown,
    ScoutFormPrefecture,
    ScoutFormOthers,
    ScoutFormSpecialFavor
  },
  props: {
    scoutedMemberObjects: {
      type: Array,
      default: () => ([])
    },
    searchParameter: {
      type: Object,
      default: () => ({
        gender: null,
        educationalBackground: null,
        employed: null,
        hasCareerResumes: false,
        presentAddressPrefectures: []
      })
    }
  },
  data () {
    return {
      readingStatusOptions: definition.readingStatus, // 1: 既読 2: 未読
      filterData: _.cloneDeep(defaultFilterData),
      filterScoutedMemberObjects: [],
      renderModal: true
    }
  },
  computed: {
    searchConditionNames () {
      return _(this.scoutedMemberObjects).map(_.property('member.searchConditionName')).uniq().compact().map(v => {
        return { id: v, name: v }
      }).value()
    },
    subjects () {
      return _(this.scoutedMemberObjects).map(_.property('member.scout.latestMessage.subject')).uniq().compact().map(v => {
        return { id: v, name: v }
      }).value()
    },
    reservedInfos () {
      return _(this.scoutedMemberObjects).map(_.property('member.reservationLogs')).flattenDeep().uniq().compact().map(v => {
        return { id: v, name: v }
      }).value()
    }
  },
  watch: {
    filterData: {
      handler () {
        this.filter()
      },
      deep: true
    },
    'scoutedMemberObjects' () {
      this.filter()
    }
  },
  created () {
    const masters = [
      'specialFavors'
    ]
    masters.forEach(element => {
      this.storeMaster(element)
    })
  },
  methods: {
    ...mapActions({
      storeMaster: 'storeMaster'
    }),
    sendDateFromFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => _.get(scoutedMemberObject, 'member.scout.latestMessage.insertDate') &&
        createDate(scoutedMemberObject.member.scout.latestMessage.insertDate)?.startOf('day').isSameOrAfter(this.filterData.sendDate.from))
    },
    sendDateToFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => _.get(scoutedMemberObject, 'member.scout.latestMessage.insertDate') &&
        createDate(scoutedMemberObject.member.scout.latestMessage.insertDate)?.startOf('day').isSameOrBefore(this.filterData.sendDate.to))
    },
    userIdFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => String(_.get(scoutedMemberObject, 'member.id')).match('^' + this.filterData.userId))
    },
    sendCountFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => _.get(scoutedMemberObject, 'member.scout.messagesCount') === this.filterData.sendCount)
    },
    readFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => !_.isEmpty(_.get(scoutedMemberObject, 'member.scout.latestMessage.readDate')))
    },
    noReadFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => _.isEmpty(_.get(scoutedMemberObject, 'member.scout.latestMessage.readDate')))
    },
    searchConditionNameFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => _.get(scoutedMemberObject, 'member.searchConditionName') === this.filterData.searchConditionName)
    },
    subjectFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => _.get(scoutedMemberObject, 'member.scout.latestMessage.subject') === this.filterData.subject)
    },
    excludesLikedFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => !scoutedMemberObject.member.liked)
    },
    resendableFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => !scoutedMemberObject.member.isWithdrawn && scoutedMemberObject.member.subscriptions.scout &&
        !scoutedMemberObject.member.isEntry && !scoutedMemberObject.member.isScoutRejection &&
        !scoutedMemberObject.member.isCkUser && !scoutedMemberObject.member.isScoutExcluded && !scoutedMemberObject.member.isScoutReserved &&
        !scoutedMemberObject.member.isScoutDecline && !scoutedMemberObject.member.isScoutedToday)
    },
    specialFavorFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => _.get(scoutedMemberObject, 'member.scout.specialFavors', []).some(specialFavor => _.includes(this.filterData.specialFavorIds, specialFavor.id + '')))
    },
    genderFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => _.get(scoutedMemberObject, 'member.gender.id') === this.filterData.gender)
    },
    educationalBackgroundFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => scoutedMemberObject.member.educationalBackground && scoutedMemberObject.member.educationalBackground.id <= this.filterData.educationalBackground)
    },
    employedFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => scoutedMemberObject.member.employed === this.filterData.employed)
    },
    presentAddressPrefectureFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => scoutedMemberObject.member.presentAddressPrefecture && this.filterData.presentAddressPrefectures.some(presentAddressPrefectureId => presentAddressPrefectureId === scoutedMemberObject.member.presentAddressPrefecture.id))
    },
    careerResumeFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => !_.isEmpty(scoutedMemberObject.member.careerResume))
    },
    reservedInfoFilter (filterScoutedMemberObjects) {
      return filterScoutedMemberObjects.filter(scoutedMemberObject => _.get(scoutedMemberObject, 'member.reservationLogs').includes(this.filterData.reservedInfo))
    },
    filter () {
      let filterScoutedMemberObjects = _(this.scoutedMemberObjects)
      filterScoutedMemberObjects = this.filterData.sendDate.from ? this.sendDateFromFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.sendDate.to ? this.sendDateToFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.userId ? this.userIdFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.sendCount ? this.sendCountFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.readingStatus === '1' ? this.readFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.readingStatus === '2' ? this.noReadFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.searchConditionName ? this.searchConditionNameFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.subject ? this.subjectFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.excludesLiked ? this.excludesLikedFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.includesResend ? this.resendableFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.specialFavorIds.length ? this.specialFavorFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.gender ? this.genderFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.educationalBackground ? this.educationalBackgroundFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.employed !== null ? this.employedFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.presentAddressPrefectures.length ? this.presentAddressPrefectureFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.hasCareerResumes ? this.careerResumeFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      filterScoutedMemberObjects = this.filterData.reservedInfo ? this.reservedInfoFilter(filterScoutedMemberObjects) : filterScoutedMemberObjects
      this.$set(this, 'filterScoutedMemberObjects', filterScoutedMemberObjects.value())
      this.$emit('setMemberObjects', this.filterScoutedMemberObjects)
    },
    clearFilterData () {
      this.$set(this, 'filterData', _.cloneDeep(defaultFilterData))
      this.rerender()
    },
    rerender () {
      // モーダル初期化のため
      this.$set(this, 'renderModal', false)
      this.$nextTick(() => {
        this.$set(this, 'renderModal', true)
      })
    }
  }
}
</script>
